import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue } from "bootstrap-vue";
import Aurora from "aurora-vue";
import "./custom.scss";
import ApiClient from "./ApiClient";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faAngleUp,
  faTrash,
  faArrowRight,
  faMinusCircle,
  faPlus,
  faCopy,
  faEdit,
  faUserTie
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faAngleDown);
library.add(faAngleUp);
library.add(faTrash);
library.add(faArrowRight);
library.add(faMinusCircle);
library.add(faPlus);
library.add(faCopy);
library.add(faEdit);
library.add(faUserTie);

Vue.component("font-awesome-icon", FontAwesomeIcon);
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
// Install BootstrapVue
Vue.use(BootstrapVue);
Vue.use(Aurora);

Vue.config.productionTip = false;

const BASE_PATH = process.env.VUE_APP_BASE_URL;

Vue.prototype.$client = new ApiClient(BASE_PATH);
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
